import { apiService } from "./api";

export interface CreateOrderRequest {
  productId: string;
  variantId?: string | null;
  customerName: string;
  customerPhone: string;
  wilaya: string;
  commune: string;
  notes?: string | null;
}

export interface Order {
  id: string;
  orderNumber: string;
  product: {
    id: string;
    name: string;
    category?: {
      id: string;
      name: string;
    };
  };
  variant: {
    id: string;
    variantType: string;
    variantValue: string;
    priceAdjustment: number;
  } | null;
  customerName: string;
  customerPhone: string;
  wilaya: string;
  commune: string;
  notes: string | null;
  status: "new" | "confirmed" | "preparing" | "shipped" | "canceled";
  finalPrice: number;
  pixelEventId: string | null;
  createdAt: string;
  updatedAt: string;
  statusUpdatedAt: string | null;
  statusUpdatedBy: string | null;
}

export const orderService = {
  create: async (orderData: CreateOrderRequest): Promise<Order> => {
    return await apiService.post<Order>("/orders", orderData);
  },
};

